import React, { useState, useEffect, useRef } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useParams, useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputSwitch } from 'primereact/inputswitch';

//import SignaturePad from '../signature/SignaturePad';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faCheck, faWind, faCodeBranch, faList, faBackward, faFile, faInfo, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import { classNames } from 'primereact/utils';
import { ProgressBar } from 'primereact/progressbar';
// Import PkgpService for CRUD operations
import PkgpService from '../../service/PkgpService';
import { QrScaner } from '../../utilities/QrScaner';

// Import all related models
//
import MmService from '../../service/MmService';

// Import related store

//import { useMm } from '../../store/index';
import { useRvp } from '../../store/index';
import { useNi } from '../../store/index';
import { useSi } from '../../store/index';
import { useUsers } from '../../store/index';
// import { useGroups } from '../../store/index'; // removed unused

import moment from 'moment';
import { useYupValidationResolver } from '../../utilities/useYupValidationResolver';
import * as yup from 'yup';
import i18n from '../../i18n';
import MmSelect from '../mm/MmSelect';
import MMInfo from '../mm/MMInfo';
import { CanAccess, StartButton, EndButton } from '../permissions';
import { usePermissions } from '../../hooks/usePermissions';
import LocationService from '../geolocator/LocationService';

/* Validation schema */
const validationSchema = yup.object().shape({
    mm_id: yup.string().required('mm_id is required.'),
    vp: yup.boolean().required('vp is required.'),
    pp_id: yup.string().required('pp_id is required.')
});

// translation with parameters

// Aca , Ivan, Nikola

const storage = process.env.REACT_APP_STORAGE_URL || 'http://localhost:8000/storage/';

function PkgpStepsForm() {
    const [model, setModel] = useState([]);
    const [deleteModelDialog, setDeleteModelDialog] = useState(false);
    const [mmSelectDialog, setMmSelectDialog] = useState(false);
    const [actionType, setActionType] = useState('');
    const [signatureDialog, setSignatureDialog] = useState(false);
    // const [mms, setMms] = useState([]);
    const [showQrScaner, setShowQrScaner] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [saving, setSaving] = useState(false); // auto-save state
    const gatingWarnShown = useRef(false); // da ne spamujemo poruku

    const toast = useRef(null);
    const navigate = useNavigate();

    const { id } = useParams(); // Uzimanje parametara iz URL-a

    // set default values for form
    const defaultValues = {
        mm_id: '',
        datum_provere: moment().format('YYYY-MM-DD'),
        vp: false,
        rvp_id: '',
        ni_id: '',
        merac_ispravan: true,
        merac_bazdaren: true,
        merac_komentar: '',
        regulator_gasa_ispravan: true,
        regulator_gasa_komentar: '',
        kutija_zamena: false,
        kutija_farbanje: false,
        bravica_zamena: false,
        kutija_komentar: '',
        ugi_ispravan: true,
        ugi_komentar: '',
        isticanje_pk: false,
        isticanje_celik: false,
        isticanje_gl_ventil: false,
        isticanje_fiter_grana: false,
        isticanje_regulator: false,
        isticanje_ul_holender: false,
        isticanje_iz_holender: false,
        isticanje_komentar: '',
        rok_otklanjanja_nedostataka: '',
        celik_korozija_zastita: false,
        celik_korozija_zastita_komentar: '',
        status_id: 1,
        si_id: 1,
        instalacija_komentar: '',
        potrosac_nije_kuci: false,
        potpis_ime_prezime: '',
        potpis_url: '',
        pocetak_provere: '',
        kraj_provere: '',
        kreirao_rn_users_id: '',
        uradio_pkgp_users_id: '',
        dodeljen_users_id: '',
        dodeljen_groups_id: '',
        dodeljen_datum: moment().format('YYYY-MM-DD'),
        pp_id: 2
    };

    const { getPkgp, deletePkgp, createPkgp, updatePkgp, startPkgp, endPkgp, pdfPkgp, uploadSignatureImage, nijeKodKuce } = PkgpService();

    // related models values

    const { rvps } = useRvp((state) => ({ rvps: state.rvps }));
    const { nis } = useNi((state) => ({ nis: state.nis }));
    const { sis } = useSi((state) => ({ sis: state.sis }));
    const { users } = useUsers((state) => ({ users: state.users }));
    // removed groups (unused after step simplification)

    const resolver = useYupValidationResolver(validationSchema);
    const { getMmsLazy } = MmService();

    const {
        control,
        formState: { errors, isDirty },
        handleSubmit,
        reset,
        watch,
        setFocus,
        setValue,
        getValues
    } = useForm({ defaultValues, resolver });

    // set focus on target input
    useEffect(() => {
        setFocus('naziv');
    }, [setFocus]);

    useEffect(() => {
        if (!id) {
            setModel([]);
            reset(defaultValues);
            setActiveIndex(0);
            return;
        }

        getPkgp(id).then((res) => {
            setModel(res.data);
            reset(res.data);
        });
    }, [id, reset]); // eslint-disable-line react-hooks/exhaustive-deps

    const vpChecked = watch('vp'); // posmatramo checkbox

    // kad se isključi, resetujemo polje rvp_id
    useEffect(() => {
        if (!vpChecked) {
            setValue('rvp_id', '');
        }
    }, [vpChecked, setValue]);

    const statusChange = watch('status_id');

    const statusTemplate = (doc) => {
        const _status = getSeverity(doc.status_id);
        return <Tag value={_status.name} severity={_status.color}></Tag>;
    };

    const getSeverity = (status) => {
        switch (status) {
            case 1:
                return { name: 'KREIRAN', color: 'danger' };

            case 2:
                return { name: 'U RADU', color: 'warning' };

            case 3:
                return { name: 'ZAVRŠEN', color: 'success' };

            default:
                return { name: 'U PRIPREMI', color: 'default' };
        }
    };

    const mmSelected = watch('mm');
    useEffect(() => {
        if (mmSelected) {
            //
        }
    }, [mmSelected]); // eslint-disable-line react-hooks/exhaustive-deps

    const onSelectMM = (selectedModel) => {
        setValue('mm', selectedModel);
        setValue('mm_id', selectedModel.id);
        setMmSelectDialog(false);
    };

    const downloadFile = (blob, filename) => {
        try {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename || 'download.pdf';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (e) {
            console.error(e);
        }
    };

    const onScanneHandler = (barkod) => {
        let filters = {};
        filters = {};
        filters['barkod[value]'] = barkod;
        filters['barkod[matchMode]'] = 'contains';

        const params = {
            page: 1,
            perPage: 1,
            sortBy: 'id',
            sortOrder: 'asc',
            paginator: false,
            ...filters
        };
        getMmsLazy(params).then((res) => {
            // console.log(res.data[0]);
            setValue('mm', res.data[0]);
            setValue('mm_id', res.data[0].id);
            setShowQrScaner(false);
        });
    };

    const onSubmit = (data) => {
        switch (actionType) {
            case 'save_exit': {
                // create or update then navigate back to list
                const afterSuccess = (resolve) => {
                    setModel(resolve.data);
                    reset(resolve.data);
                    toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: data.id ? i18n.t('success_edit') : i18n.t('success_create'), life: 3000 });
                    navigate('/');
                };
                if (data.id) {
                    updatePkgp(data.id, data).then(
                        (resolve) => afterSuccess(resolve),
                        (reject) => {
                            reject.errors.forEach((error) => {
                                toast.current.show({ severity: 'error', summary: i18n.t('error'), detail: error, life: 3000 });
                            });
                        }
                    );
                } else {
                    createPkgp(data).then(
                        (resolve) => afterSuccess(resolve),
                        (reject) => {
                            reject.errors.forEach((error) => {
                                toast.current.show({ severity: 'error', summary: i18n.t('error'), detail: error, life: 3000 });
                            });
                        }
                    );
                }
                break;
            }
            case 'save': {
                if (data.id) {
                    updatePkgp(data.id, data).then(
                        (resolve) => {
                            setModel(resolve.data);
                            reset(resolve.data);
                            toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: i18n.t('success_edit'), life: 3000 });
                        },
                        (reject) => {
                            // foreach errors and show toast
                            reject.errors.forEach((error) => {
                                toast.current.show({ severity: 'error', summary: i18n.t('error'), detail: error, life: 3000 });
                            });
                        }
                    );
                } else {
                    createPkgp(data).then(
                        (resolve) => {
                            setModel(resolve.data);
                            reset(resolve.data);
                            toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: i18n.t('success_create'), life: 3000 });
                            navigate(`/pkgp/${resolve.data.id}/edit`);
                        },
                        (reject) => {
                            // foreach errors and show toast
                            reject.errors.forEach((error) => {
                                toast.current.show({ severity: 'error', summary: i18n.t('error'), detail: error, life: 3000 });
                            });
                        }
                    );
                }
                break;
            }
            case 'start': {
                // Front-end guard: cannot start if consumer not at home
                if (data.potrosac_nije_kuci) {
                    toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Ne možete započeti proveru dok potrošač nije kod kuće.', life: 3000 });
                    setActionType('');
                    return;
                }
                startPkgp(data).then(
                    (resolve) => {
                        setModel(resolve.data);
                        reset(resolve.data);
                        toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: resolve.message, life: 3000 });

                        // if data.id exists stay on the same page
                        if (data.id) {
                            // odmah prebacije na sledeći korak
                            setActiveIndex(1);
                            // Logic for when data.id exists
                        } else {
                            navigate(`/pkgp/${resolve.data.id}/edit`);
                        }
                    },
                    (reject) => {
                        // foreach errors and show toast
                        reject.errors.forEach((error) => {
                            toast.current.show({ severity: 'error', summary: i18n.t('error'), detail: error, life: 3000 });
                        });
                    }
                );

                break;
            }

            case 'end': {
                if (!isInstallationFilled()) {
                    toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Unesite stanje instalacije pre završetka.', life: 3000 });
                    setActionType('');
                    break;
                }
                endPkgp(data).then(
                    (resolve) => {
                        setModel(resolve.data);
                        reset(resolve.data);
                        toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: i18n.t('end_check'), life: 3000 });
                        setTimeout(() => {
                            navigate('/');
                        }, 2000);
                    },
                    (reject) => {
                        // foreach errors and show toast
                        reject.errors.forEach((error) => {
                            toast.current.show({ severity: 'error', summary: i18n.t('error'), detail: error, life: 3000 });
                        });
                    }
                );

                break;
            }
            case 'back': {
                navigate('/');
                break;
            }
            case 'pdf': {
                pdfPkgp(data.id)
                    .then(({ blob, filename }) => {
                        downloadFile(blob, filename);
                    })
                    .catch(() => {
                        toast.current?.show({ severity: 'error', summary: i18n.t('error'), detail: 'PDF', life: 3000 });
                    });

                break;
            }

            default: {
                break;
            }
        }

        setActionType(''); // reset action type
    };

    const getFormErrorMessage = (name) => {
        return errors[name] && <small className="p-error">{errors[name].message}</small>;
    };

    const hideDeleteModelDialog = () => {
        setDeleteModelDialog(false);
    };

    // const confirmDeleteModel = () => setDeleteModelDialog(true); // removed (delete disabled in current UI)

    const deleteModel = () => {
        deletePkgp(model.id).then((res) => {
            hideDeleteModelDialog();
            toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: i18n.t('success_deleted'), life: 3000 });
            navigate('/pkgp');
        });
    };

    const deleteModelDialogFooter = (
        <React.Fragment>
            <Button label={i18n.t('no')} icon="pi pi-times" outlined onClick={hideDeleteModelDialog} />
            <Button label={i18n.t('yes')} icon="pi pi-check" severity="danger" onClick={deleteModel} />
        </React.Fragment>
    );

    // const onSignature = async (formData) => {
    //     try {
    //         uploadSignatureImage(model.id, formData).then((response) => {
    //             setSignatureDialog(false);
    //             setModel(response.data);
    //             reset(response.data);
    //             toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: i18n.t('image_uploaded'), life: 3000 });
    //         });
    //     } catch (error) {
    //         console.error('Upload failed:', error.response?.data || error.message);
    //     }
    // };

    // Watch values for conditional comment field visibility
    const meracIspravan = watch('merac_ispravan');
    const meracBazdaren = watch('merac_bazdaren');
    const regulatorGasaIspravan = watch('regulator_gasa_ispravan');
    const ugiIspravan = watch('ugi_ispravan');
    const isticanjePk = watch('isticanje_pk');
    const isticanjeCelik = watch('isticanje_celik');
    const isticanjeGlVentil = watch('isticanje_gl_ventil');
    const isticanjeFiterGrana = watch('isticanje_fiter_grana');
    const isticanjeRegulator = watch('isticanje_regulator');
    const isticanjeUlHolender = watch('isticanje_ul_holender');
    const isticanjeIzHolender = watch('isticanje_iz_holender');
    const celikKorozijaZastita = watch('celik_korozija_zastita');
    const siId = watch('si_id');
    const kutijaZamena = watch('kutija_zamena');
    const kutijaFarbanje = watch('kutija_farbanje');
    const bravicaZamena = watch('bravica_zamena');

    // Check if comment fields should be visible
    const shouldShowMeracKomentar = meracIspravan !== defaultValues.merac_ispravan || meracBazdaren !== defaultValues.merac_bazdaren;
    const shouldShowRegulatorKomentar = regulatorGasaIspravan !== defaultValues.regulator_gasa_ispravan;
    const shouldShowKutijaKomentar = kutijaZamena !== defaultValues.kutija_zamena || kutijaFarbanje !== defaultValues.kutija_farbanje || bravicaZamena !== defaultValues.bravica_zamena;
    const shouldShowUgiKomentar = ugiIspravan !== defaultValues.ugi_ispravan;
    const shouldShowIsticanjeKomentar =
        isticanjePk !== defaultValues.isticanje_pk ||
        isticanjeCelik !== defaultValues.isticanje_celik ||
        isticanjeGlVentil !== defaultValues.isticanje_gl_ventil ||
        isticanjeFiterGrana !== defaultValues.isticanje_fiter_grana ||
        isticanjeRegulator !== defaultValues.isticanje_regulator ||
        isticanjeUlHolender !== defaultValues.isticanje_ul_holender ||
        isticanjeIzHolender !== defaultValues.isticanje_iz_holender;
    const shouldShowCelikKomentar = celikKorozijaZastita !== defaultValues.celik_korozija_zastita;
    const shouldShowInstalacijaKomentar = siId !== defaultValues.si_id && siId != null;

    const { canStartPkgp, canEndPkgp } = usePermissions();

    const stepDefinitions = ['Merno mesto', 'Stavke za proveru', 'Instalacija'];
    const isInstallationFilled = () => {
        const val = getValues('si_id');
        return !!val;
    };

    const validateStep = () => {
        if (activeIndex === 0 && !getValues('mm_id')) {
            toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Odaberite merno mesto', life: 2500 });
            return false;
        }
        if (activeIndex === 0 && getValues('potrosac_nije_kuci')) {
            toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Potrošač nije kod kuće - ne možete nastaviti.', life: 3000 });
            return false;
        }
        return true;
    };

    const goNext = async () => {
        if (saving) return; // prevent double click
        if (!validateStep()) return;
        if (activeIndex >= 1 && statusChange === 1) {
            toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Započnite proveru pre nastavka na sledeće korake.', life: 3000 });
            return;
        }
        // autosave only if there are unsaved changes
        const dirty = isDirty; // from react-hook-form
        if (dirty) {
            try {
                setSaving(true);
                const formData = getValues();
                if (formData.id) {
                    await updatePkgp(formData.id, formData).then((resolve) => {
                        setModel(resolve.data);
                        reset(resolve.data); // reset dirty state
                    });
                } else {
                    await createPkgp(formData).then((resolve) => {
                        setModel(resolve.data);
                        reset(resolve.data);
                        navigate(`/pkgp/${resolve.data.id}/edit`);
                    });
                }
            } catch (e) {
                toast.current?.show({ severity: 'error', summary: 'Greška', detail: 'Auto čuvanje nije uspelo.', life: 3000 });
                setSaving(false);
                return; // ne idemo dalje ako save padne
            }
            setSaving(false);
        }
        setActiveIndex((i) => Math.min(i + 1, stepDefinitions.length - 1));
    };
    const goPrev = () => {
        if (activeIndex === 0) {
            navigate(-1);
            return;
        }
        setActiveIndex((i) => Math.max(i - 1, 0));
    };

    // Ako se status vrati/učita kao 1 (nije startovano) i aktivan korak >1, vratimo korisnika na 1
    useEffect(() => {
        if (statusChange === 1 && activeIndex > 1) {
            setActiveIndex(1);
            if (!gatingWarnShown.current) {
                toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Nije moguće ići dalje dok ne započnete proveru.', life: 3000 });
                gatingWarnShown.current = true;
            }
        }
        if (statusChange !== 1) {
            gatingWarnShown.current = false; // reset kada se otključa
        }
    }, [statusChange, activeIndex]);

    const renderStepContent = () => {
        switch (activeIndex) {
            case 0:
                return (
                    <div key="step-0" className="grid formgrid p-fluid px-1">
                        {watch('mm') ? <MMInfo mm={watch('mm')} /> : ''}
                        {mmSelected && statusChange === 1 && (
                            <div className="field md:col-4 col-12 flex align-items-end gap-3 flex-wrap">
                                <Button
                                    type="button"
                                    severity="warning"
                                    outlined
                                    icon="pi pi-home"
                                    label="Potrošač nije kod kuće"
                                    onClick={async () => {
                                        if (!id) {
                                            toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Prvo sačuvajte nalog.', life: 3000 });
                                            return;
                                        }
                                        try {
                                            const locationService = LocationService();
                                            let geoData = {};
                                            try {
                                                const loc = await locationService.getCurrentLocation();
                                                geoData = { latitude: loc.latitude, longitude: loc.longitude, accuracy: loc.accuracy };
                                            } catch (geoErr) {
                                                console.warn('GPS nije dostupan:', geoErr.message);
                                            }
                                            await nijeKodKuce(id, geoData);
                                            setValue('potrosac_nije_kuci', true);
                                            toast.current?.show({ severity: 'success', summary: 'Evidentirano', detail: 'Potrošač nije kod kuće - izlazak zabeležen.', life: 4000 });
                                        } catch (e) {
                                            const msg = e?.response?.data?.message || 'Nije moguće evidentirati izlazak.';
                                            toast.current?.show({ severity: 'error', summary: 'Greška', detail: msg, life: 3000 });
                                        }
                                    }}
                                />
                                <div className="field md:col-2 col-12">
                                    <label htmlFor="potrosac_nije_kuci" className={classNames('w-12', { 'p-error': errors.potrosac_nije_kuci })}>
                                        {i18n.t('pkgp.potrosac_nije_kuci')}
                                    </label>
                                    <Controller
                                        name="potrosac_nije_kuci"
                                        control={control}
                                        render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} disabled={statusChange > 1} className={classNames({ invalid: fieldState.invalid })} />}
                                    />
                                    {getFormErrorMessage('potrosac_nije_kuci')}
                                    {watch('potrosac_nije_kuci') && statusChange === 1 && (
                                        <small className="p-warning block" style={{ color: 'var(--yellow-600)' }}>
                                            Ne možete započeti proveru dok je ova opcija uključena.
                                        </small>
                                    )}
                                </div>
                            </div>
                        )}

                        <div className="field md:col-2 col-12">
                            <label htmlFor="vp" className={classNames('w-12', { 'p-error': errors.vp })}>
                                {i18n.t('pkgp.vp')}
                            </label>
                            <Controller name="vp" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('vp')}
                        </div>
                        {vpChecked && (
                            <div className="field md:col-2 col-12">
                                <label htmlFor="rvp_id" className={classNames({ 'p-error': errors.rvp_id })}>
                                    {i18n.t('pkgp.rvp_id')}
                                </label>
                                <Controller
                                    name="rvp_id"
                                    control={control}
                                    render={({ field, fieldState }) => <Dropdown id={field.name} {...field} options={rvps} optionLabel="opis" optionValue="id" className={classNames({ invalid: fieldState.invalid })} />}
                                />
                                {getFormErrorMessage('rvp_id')}
                            </div>
                        )}
                    </div>
                );
            case 1:
                return (
                    <div key="step-1" className="grid formgrid p-fluid px-1">
                        <div className="field md:col-2 col-12">
                            <label htmlFor="ni_id" className={classNames({ 'p-error': errors.ni_id })}>
                                {i18n.t('pkgp.ni_id')}
                            </label>
                            <Controller
                                name="ni_id"
                                control={control}
                                render={({ field, fieldState }) => <Dropdown id={field.name} {...field} options={nis} optionLabel="opis" optionValue="id" className={classNames({ invalid: fieldState.invalid })} />}
                            />
                            {getFormErrorMessage('ni_id')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="merac_ispravan" className={classNames('w-12', { 'p-error': errors.merac_ispravan })}>
                                {i18n.t('pkgp.merac_ispravan')}
                            </label>
                            <Controller name="merac_ispravan" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('merac_ispravan')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="merac_bazdaren" className={classNames('w-12', { 'p-error': errors.merac_bazdaren })}>
                                {i18n.t('pkgp.merac_bazdaren')}
                            </label>
                            <Controller name="merac_bazdaren" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('merac_bazdaren')}
                        </div>
                        {shouldShowMeracKomentar && (
                            <div className="field md:col-2 col-12">
                                <label htmlFor="merac_komentar" className={classNames({ 'p-error': errors.merac_komentar })}>
                                    {i18n.t('pkgp.merac_komentar')}
                                </label>
                                <Controller name="merac_komentar" control={control} render={({ field, fieldState }) => <InputText id={field.name} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                                {getFormErrorMessage('merac_komentar')}
                            </div>
                        )}
                        <div className="field md:col-2 col-12">
                            <label htmlFor="regulator_gasa_ispravan" className={classNames('w-12', { 'p-error': errors.regulator_gasa_ispravan })}>
                                {i18n.t('pkgp.regulator_gasa_ispravan')}
                            </label>
                            <Controller
                                name="regulator_gasa_ispravan"
                                control={control}
                                render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />}
                            />
                            {getFormErrorMessage('regulator_gasa_ispravan')}
                        </div>
                        {shouldShowRegulatorKomentar && (
                            <div className="field md:col-2 col-12">
                                <label htmlFor="regulator_gasa_komentar" className={classNames({ 'p-error': errors.regulator_gasa_komentar })}>
                                    {i18n.t('pkgp.regulator_gasa_komentar')}
                                </label>
                                <Controller name="regulator_gasa_komentar" control={control} render={({ field, fieldState }) => <InputText id={field.name} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                                {getFormErrorMessage('regulator_gasa_komentar')}
                            </div>
                        )}
                        <div className="field md:col-2 col-6">
                            <label htmlFor="kutija_zamena" className={classNames('w-12', { 'p-error': errors.kutija_zamena })}>
                                {i18n.t('pkgp.kutija_zamena')}
                            </label>
                            <Controller name="kutija_zamena" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('kutija_zamena')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="kutija_farbanje" className={classNames('w-12', { 'p-error': errors.kutija_farbanje })}>
                                {i18n.t('pkgp.kutija_farbanje')}
                            </label>
                            <Controller name="kutija_farbanje" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('kutija_farbanje')}
                        </div>
                        <div className="field md:col-2 col-12">
                            <label htmlFor="bravica_zamena" className={classNames('w-12', { 'p-error': errors.bravica_zamena })}>
                                {i18n.t('pkgp.bravica_zamena')}
                            </label>
                            <Controller name="bravica_zamena" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('bravica_zamena')}
                        </div>
                        {shouldShowKutijaKomentar && (
                            <div className="field md:col-2 col-12">
                                <label htmlFor="kutija_komentar" className={classNames({ 'p-error': errors.kutija_komentar })}>
                                    {i18n.t('pkgp.kutija_komentar')}
                                </label>
                                <Controller name="kutija_komentar" control={control} render={({ field, fieldState }) => <InputText id={field.name} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                                {getFormErrorMessage('kutija_komentar')}
                            </div>
                        )}
                        <div className="field md:col-2 col-6">
                            <label htmlFor="ugi_ispravan" className={classNames('w-12', { 'p-error': errors.ugi_ispravan })}>
                                {i18n.t('pkgp.ugi_ispravan')}
                            </label>
                            <Controller name="ugi_ispravan" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('ugi_ispravan')}
                        </div>
                        {shouldShowUgiKomentar && (
                            <div className="field md:col-2 col-12">
                                <label htmlFor="ugi_komentar" className={classNames({ 'p-error': errors.ugi_komentar })}>
                                    {i18n.t('pkgp.ugi_komentar')}
                                </label>
                                <Controller name="ugi_komentar" control={control} render={({ field, fieldState }) => <InputText id={field.name} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                                {getFormErrorMessage('ugi_komentar')}
                            </div>
                        )}
                    </div>
                );
            case 2:
                return (
                    <div key="step-2" className="grid formgrid p-fluid px-1">
                        <div className="field md:col-2 col-6">
                            <label htmlFor="isticanje_pk" className={classNames('w-12', { 'p-error': errors.isticanje_pk })}>
                                {i18n.t('pkgp.isticanje_pk')}
                            </label>
                            <Controller name="isticanje_pk" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('isticanje_pk')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="isticanje_celik" className={classNames('w-12', { 'p-error': errors.isticanje_celik })}>
                                {i18n.t('pkgp.isticanje_celik')}
                            </label>
                            <Controller name="isticanje_celik" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('isticanje_celik')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="isticanje_gl_ventil" className={classNames('w-12', { 'p-error': errors.isticanje_gl_ventil })}>
                                {i18n.t('pkgp.isticanje_gl_ventil')}
                            </label>
                            <Controller name="isticanje_gl_ventil" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('isticanje_gl_ventil')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="isticanje_fiter_grana" className={classNames('w-12', { 'p-error': errors.isticanje_fiter_grana })}>
                                {i18n.t('pkgp.isticanje_fiter_grana')}
                            </label>
                            <Controller
                                name="isticanje_fiter_grana"
                                control={control}
                                render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />}
                            />
                            {getFormErrorMessage('isticanje_fiter_grana')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="isticanje_regulator" className={classNames('w-12', { 'p-error': errors.isticanje_regulator })}>
                                {i18n.t('pkgp.isticanje_regulator')}
                            </label>
                            <Controller name="isticanje_regulator" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('isticanje_regulator')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="isticanje_ul_holender" className={classNames('w-12', { 'p-error': errors.isticanje_ul_holender })}>
                                {i18n.t('pkgp.isticanje_ul_holender')}
                            </label>
                            <Controller
                                name="isticanje_ul_holender"
                                control={control}
                                render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />}
                            />
                            {getFormErrorMessage('isticanje_ul_holender')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="isticanje_iz_holender" className={classNames('w-12', { 'p-error': errors.isticanje_iz_holender })}>
                                {i18n.t('pkgp.isticanje_iz_holender')}
                            </label>
                            <Controller
                                name="isticanje_iz_holender"
                                control={control}
                                render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />}
                            />
                            {getFormErrorMessage('isticanje_iz_holender')}
                        </div>
                        {shouldShowIsticanjeKomentar && (
                            <div className="field md:col-2 col-12">
                                <label htmlFor="isticanje_komentar" className={classNames({ 'p-error': errors.isticanje_komentar })}>
                                    {i18n.t('pkgp.isticanje_komentar')}
                                </label>
                                <Controller name="isticanje_komentar" control={control} render={({ field, fieldState }) => <InputText id={field.name} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                                {getFormErrorMessage('isticanje_komentar')}
                            </div>
                        )}
                        <div className="field md:col-2 col-6">
                            <label htmlFor="celik_korozija_zastita" className={classNames('w-12', { 'p-error': errors.celik_korozija_zastita })}>
                                {i18n.t('pkgp.celik_korozija_zastita')}
                            </label>
                            <Controller
                                name="celik_korozija_zastita"
                                control={control}
                                render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />}
                            />
                            {getFormErrorMessage('celik_korozija_zastita')}
                        </div>
                        {shouldShowCelikKomentar && (
                            <div className="field md:col-2 col-12">
                                <label htmlFor="celik_korozija_zastita_komentar" className={classNames({ 'p-error': errors.celik_korozija_zastita_komentar })}>
                                    {i18n.t('pkgp.celik_korozija_zastita_komentar')}
                                </label>
                                <Controller name="celik_korozija_zastita_komentar" control={control} render={({ field, fieldState }) => <InputText id={field.name} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                                {getFormErrorMessage('celik_korozija_zastita_komentar')}
                            </div>
                        )}
                        <div className="field md:col-2 col-12">
                            <label htmlFor="si_id" className={classNames({ 'p-error': errors.si_id })}>
                                {i18n.t('pkgp.si_id')}
                            </label>
                            <Controller
                                name="si_id"
                                control={control}
                                render={({ field, fieldState }) => <Dropdown id={field.name} {...field} options={sis} optionLabel="opis" optionValue="id" className={classNames({ invalid: fieldState.invalid })} />}
                            />
                            {getFormErrorMessage('si_id')}
                        </div>
                        {shouldShowInstalacijaKomentar && (
                            <React.Fragment>
                                <div className="field md:col-2 col-12">
                                    <label htmlFor="instalacija_komentar" className={classNames({ 'p-error': errors.instalacija_komentar })}>
                                        {i18n.t('pkgp.instalacija_komentar')}
                                    </label>
                                    <Controller name="instalacija_komentar" control={control} render={({ field, fieldState }) => <InputText id={field.name} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                                    {getFormErrorMessage('instalacija_komentar')}
                                </div>
                                <div className="field md:col-2 col-12">
                                    <label htmlFor="rok_otklanjanja_nedostataka" className={classNames({ 'p-error': errors.rok_otklanjanja_nedostataka })}>
                                        {i18n.t('pkgp.rok_otklanjanja_nedostataka')}
                                    </label>
                                    <Controller
                                        name="rok_otklanjanja_nedostataka"
                                        control={control}
                                        render={({ field, fieldState }) => <InputText id={field.name} {...field} keyfilter="pint" className={classNames({ invalid: fieldState.invalid })} />}
                                    />
                                    {getFormErrorMessage('rok_otklanjanja_nedostataka')}
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div className="form-pkgp">
            <Toast ref={toast} />
            <div className="surface-card border-round shadow-2 p-4 min-h-full">
                <div className="grid">
                    <div className="col-12 ">
                        <span className="text-900 text-xl font-medium mb-4 block flex align-items-center justify-content-between">
                            {i18n.t('pkgp.model')} {id && `#${id}`}
                            <span className="mr-2 mb-2   "> {model && statusTemplate(model)}</span>
                        </span>
                        <div className="mb-4">
                            <div className="flex align-items-center justify-content-between mb-1">
                                <small className="text-600">
                                    Korak {activeIndex + 1} / {stepDefinitions.length}
                                </small>
                                <small className="text-600">{stepDefinitions[activeIndex]}</small>
                            </div>
                            <ProgressBar value={Math.round(((activeIndex + 1) / stepDefinitions.length) * 100)} showValue={false} style={{ height: '6px' }} />
                        </div>
                        <form onSubmit={handleSubmit(onSubmit)} className=" " style={{ paddingBottom: '6rem' }}>
                            {renderStepContent()}

                            <div className="pkgp-action-bar fixed bottom-0 left-0 right-0 w-full flex flex-wrap gap-2 justify-content-between align-items-center surface-card border-top-1 surface-border p-3" style={{ zIndex: 100 }}>
                                <Button type="button" label="Nazad" size="large" icon="pi pi-angle-left" outlined onClick={goPrev} />
                                {/* Save button removed in gated simplified flow */}

                                <CanAccess module="pkgp" action="start">
                                    {statusChange === 1 && !getValues('potrosac_nije_kuci') && (
                                        <StartButton module="pkgp" disabled={!getValues('mm_id') || !canStartPkgp()} size="large" label={i18n.t('start_check')} type="submit" onClick={() => setActionType('start')} />
                                    )}
                                    {statusChange === 1 && getValues('potrosac_nije_kuci') && (
                                        <Button type="submit" size="large" icon="pi pi-save" severity="info" label={i18n.t('save') || 'Sačuvaj'} onClick={() => setActionType('save_exit')} disabled={!getValues('mm_id')} />
                                    )}
                                </CanAccess>

                                <CanAccess module="pkgp" action="end">
                                    {statusChange === 2 && activeIndex === stepDefinitions.length - 1 && (
                                        <EndButton module="pkgp" disabled={getValues('potrosac_nije_kuci') || !canEndPkgp() || !isInstallationFilled()} size="large" label={i18n.t('end_check')} type="submit" onClick={() => setActionType('end')} />
                                    )}
                                </CanAccess>

                                {activeIndex < stepDefinitions.length - 1 && !(activeIndex === 1 && statusChange === 1) && !(activeIndex === 0 && statusChange === 1) && (
                                    <Button type="button" size="large" label={saving ? 'Čuvanje...' : 'Dalje'} iconPos="right" icon={saving ? 'pi pi-spin pi-spinner' : 'pi pi-angle-right'} onClick={goNext} disabled={saving} />
                                )}
                                {statusChange === 3 && <Button outlined icon={<FontAwesomeIcon icon={faBackward} className="mr-2" />} size="large" label={i18n.t('back_to_list')} type="submit" onClick={() => setActionType('back')} />}
                                {/* Delete button intentionally hidden */}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <Dialog visible={deleteModelDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Potvrdi" modal footer={deleteModelDialogFooter} onHide={hideDeleteModelDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {model && (
                        <span>
                            {i18n.t('delete_confirmation')} <b>{model.naziv}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
            <Dialog visible={mmSelectDialog} style={{ width: '80rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={false} modal onHide={() => setMmSelectDialog(false)}>
                <MmSelect
                    onAfterSelect={(selectedModel) => {
                        onSelectMM(selectedModel);
                    }}
                />
            </Dialog>

            {/* <Dialog visible={signatureDialog} style={{ width: '100rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={false} modal onHide={() => setSignatureDialog(false)}>
                <SignaturePad onSaveImage={onSignature} />
            </Dialog> */}
            <Dialog header={'Bar kod čitač'} visible={showQrScaner} style={{ minWidth: '24rem' }} onHide={() => setShowQrScaner(false)}>
                <QrScaner onScane={onScanneHandler}></QrScaner>
            </Dialog>
            {/* <pre>{JSON.stringify(model, null, 2)}</pre> */}
        </div>
    );
}

export default PkgpStepsForm;

